/**
 * Appeal Content Report UseCase
 *
 * Mirrors Flutter ReportRepository.appealReportedContent →
 * ReportService.appealReportedContent
 * (lib/services/report_service.dart:23, lib/presentation/screens/content/content_report_appeal_screen.dart).
 */

import { reportService } from '@/domain/services/report/reportService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class AppealContentReportUseCase {
  async execute(contentId: string, comment: string): Promise<boolean> {
    try {
      return await reportService.appealReportedContent(contentId, comment);
    } catch (error) {
      appLogger.error('Error appealing content report', 'AppealContentReportUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const appealContentReportUseCase = new AppealContentReportUseCase();
